export const l = {
  language: 'English',
  header: {
    title: '迈拓',
    // 首页
    homeLink: '首页',
    // 产品
    productLink: '产品服务',
    business: '商业案例',
    smartExecutionLink: '智能交易',
    Electricpower: '电力',
    goBack: '返回顶部',
    smartAnalyticsLink: '智能投研',
    industrialChainLink: '产业链风控',
    edu: '教育科研',
    transactionMonitoring: '交易监察自查',
    // 关于我们
    aboutLink: '关于我们',
    teamLink: '团队介绍',
    awardsLink: '公司荣誉',
    businessCase:'商业案例',
    // 联系我们
    contactLink: '联系我们',
    contactDownLink: '联系我们',
    // 登录
    loginLink: '登录',
    phone: '联系电话',
    email: '联系邮箱'

  },
  home: {
    mandate: '我们的愿景:',
    mandateSec: '成就更好的市场',
    introTitle: '公司介绍',
    clients: '合作客户',
    intro: '杭州迈拓大数据服务有限公司是一家专注于智能监测、监管科技研发二十年，从规则性算法跨越到人工智能，致力为客户提供金融科技领域、医疗大数据领域、供应链领域及电力大数据领域精准、个性化、卓越的服务。',
  },
  products: {
    // 智能交易
    products: '产品服务',
    smartExecution: {
      signal: '交易信号激发',
      power: '电力大数据',
      powerName: '“电易省”智能楼宇设备微观故障实时监测系统，走完电力用户端最后一里路、让楼宇设备会说话、消弭物业方与维护方之间的数据鸿沟。提升楼宇设备健康，减少能耗浪费。 “电易省”微创无痛的轻量化改造，数据分析、智能算法预警、实现早期故障干预。不断提升楼宇设备的覆盖面，以中央空调为例，不光覆盖水冷/水暖系统，基于二十年经验和可靠基础设施，突破主流氟冷/暖系统实时数据协议的解析，并全面实现节能及设备延寿。',
      signalDescription: ' 自建金融市场微观结构因子库，为客户提供定制化的交易信号。',
      algorithm: '交易执行算法',
      algorithmDescription: '基于客户策略特性，为客户提供相应的交易执行算法，高效执行交易策略。',
      assessment: '智能交易评估',
      assessmentDescription: '智能评估过往交易行为，结合客户交易场景与策略，协助客户选择合适的交易执行算法。',
      management: '交易风险管控',
      managementDescription1: '结合风控算法，帮助客户执行交易的同时最大程度管控监管与合规风险。',
      managementDescription2: '避免监管与合规风险',
    },
    // 智能投研
    smartAnalytics: {
      workFlow: '管理流程智能化',
      workFlowDescription: '根据客户需求提供智能化的管理流程，如研报自动生成与管理、股票/债券池管理等，提升投研效率。',
      orderbook: '全账簿复盘工具',
      orderbookDescription: '提供最及时、精准的数据复盘，为客户提供每一笔市场行为的全生命周期追踪，帮助客户构建核心策略，提高投资效率。',
      metrics: '投研因子库',
      metricsDescription1: '以股票实时全账簿数据生成各类因子为基础，为客户提供不同频率策略所需的相关相关因子；打通期货基本面研究的数据源对接、构建数据模型、因子可视化等流程，提升期货基本面量化研究效率。',
      metricsDescription2: '期货基本面量化因子：打通期货品种基本面研究的数据源对接、数据模型构建、因子可视化等流程，极大提升期货基本面量化研究效率',
      portfolio: '智能资产组合管理工具',
      portfolioDescription: '为客户提供资产组合表现分析、业绩归因等功能，帮助客户实时了解资产组合的表现，结合压力测试、情景模拟等功能，进一步优化资产组合。',
    },
    // 产业链风控
    industryChain: {
      hedging: '套期保值管理',
      hedgingDescription1: '为客户提供基于实时数据的套保风险控制，帮助企业在事前、事中、事后全流程监控，设立预警窗口，可视化敞口指标，降低企业供应链风险。',
      reform: '企业数智化改造',
      reformDes: '企业数智化改造：为客户量身定制符合企业特点、企业环境及生产流程的数字化系统，优化各部门效率，降低生产经营风险。',
      building: '智能楼宇设备',
      buildingDescription: '迈拓大数据着眼于与企业经营息息相关的工作场景和办公环境，为企业提供智能化的楼宇设备管理以及预警机制，降低企业日常所面临的经营环境风险。'
    },
    edu:{
      imgtitle:'实验室3D效果图：',
      data:'数据',
      dataDes: '迈拓大数据是市场上少数几家能够处理金融市场超高频委托和交易数据，并提供可视化分析的机构。',
      fundation: '设施',
      fundationDes: '迈拓金融科技实验载入了全类型的金融市场实验数据，覆盖了从最底层的超高频委托和交易数据到上市公司财务数据、分析师预测数据，再到新闻和公告文本信息，真正做到了“全真实验环境”。一站式为使用者提供在全真环境中的实操训练。',
      class: '课程',
      classDes: '提供完备的金融大数据系列课程，迈拓大数据已在中央财经大学、南开大学、香港中文大学深圳校区，浙江财经大学等知名院校开展了多年沉浸式教学。',
      classDes1: '',
      classDes2: '',
      classDes3: '',
      classDes4: '',
    },
    monitor: {
      supervise: '市场监管与交易自查',
      superviseDes: '团队成员是金融市场微观结构理论的创立者，站在顶层构建相关的算法模型、模型的迭代等。迈拓核心研究人员具有全世界独一无二的证券市场监管端经验，服务了全球超60家国家级证监会及交易所，700+家券商及基金，处理过全球主要发达国家的金融市场监管级别数据，全面掌握金融市场运行机制与规则的全貌，建立了全球金融监管科技和分析科技的行业标准。'
    }
  },
  aboutUs: {
    ourTeam: {
      teamIntro: '迈拓团队',
      teamDescription: '杭州迈拓大数据拥有一支活力创新、激情不灭的团队，擅长解码隐藏在数据最深处的洞见，为金融端客户、企业端客户提供算法交易、投研管理、企业数字化改造等专业化的解决方案，致力于打造全产业链的大数据生态，成就更好的金融市场。',
      manageTeam: '管理团队',
      DrJi:'董事总经理',
      DrYu:'首席信息官',
      DrLi:'首席科学家',
      MrHuang:'首席运营官',
      MsChen:'执行董事',
      BsX: '公司副总经理',
      Cto: '首席技术总监',
      DrJiDes1: '杭州市外国高端人才（A类）',
      DrJiDes2: '江干区“百人”计划',
      DrJiDes3: '金融市场微观结构理论联合创始人',
      DrJiDes4: '麦考瑞大学金融学客座教授',
      DrJiDes5: '浙江大学资本市场研究中心特聘研究员',
      DrJiDes6: '三家估值亿元级美金公司孵化及操盘经验',
      DrYuDes1: '杭州市外国高端人才（A类）',
      DrYuDes2: '世界黄金协会高级顾问',
      DrYuDes3: '中央财经大学特聘讲师',
      DrYuDes4: '中国资本市场质量研究中心资深研究员',
      DrLiDes1: '应用数学背景',
      DrLiDes2: '国家社科基金项目主持人',
      DrLiDes3: '北京工商大学教授',
      DrLiDes4: '中国资本市场质量研究中心资深研究员',
      MrHuangDes1: '特许金融分析师（CFA）候选人',
      MrHuangDes2: '中级经济师',
      MsChenDes1: '私募基金（总规模10亿）管理人',
      MsChenDes2: '一家估值8亿公司的操盘及退出经验',
      BsXDes1: '浙大金融学背景',
      BsXDes2: '5年保险业务经验',
      BsXDes3: '5年信托业务经验',
      BsXDes4: '4年投资银行经验',
      CtoDes1: '十余年金融科技行业从业经验',
      CtoDes2: '曾任职国内金融科技龙头企业技术总监职位',
      clients: '部分合作客户'
    },
    ourAwards: {
      intro: '公司荣誉'
    }
  },
  business: {
    smarts: 'SMARTS证券市场实时交易监察系统',
    smartsDes: '迈拓团队于2004年开始进行证券市场交易公正度的研究，为了采集实证数据，着手研发捕获交易欺诈系统性方法和基础设施，最终成功创造出SMARTS证券市场实时交易监察系统。SMARTS从对证券市场各类数据的标准化着手综合了统计学、微观市场学、传统金融学等多种学科，以全账簿数据可视化回放、实时预警为特色，成为了证券交易监察领域的标准配备。美国纳斯达克交易所于2010年购买了此产品，目前已经在全球60家国家级证券会、证交所以及超过700家券商处布置开展交易监察和交易自查服务。',
    trth:'汤森路透TRTH金融市场高频交易数据平台',
    trthDes:'2007年，迈拓团队推出了科研成果商业化的第二款大数据应用一一汤森路透TRTH金融市场高频交易数据平台。在这以前，国际金融市场一直缺乏一款能向业界提供标准化的tick级别数据的平台。TRTH在推出后，以极快的扩张速度，彻底的改变了这一状况。截至2018年底，TRTH已经覆盖了全球证券交易、期货交易、债券交易、商品交易、外汇交易、能源交易中所有成规模市场的tick级别数据并以每秒钟接受处理两千万条交易数据的速度向全球用户提供准实时数据服务。',
    hibis:'HiBiS医疗保险大数据系列应用',
    hibisDes: '迈拓团队成功复制了在金融市场监管科技和分析科技领域取得的经验，在医疗保险领域又一次成功研发了全世界第一款用大数据侦测医疗保险欺诈的应用：HiBiS。目前，HiBiS已经在澳大利亚占领近90%的市场份额，并通过与美国第二大医疗数据服务提供商HMS集团的合作，成功占据了美国近20%的市场份额。在医疗保险欺诈侦测的基础上，HiBiS还衍生出了一系列旨在提升医疗市场质量的应用如外科医生选择器、分类诊疗效费比较引擎等。2021年，HMS集团整体收购了HiBiS的母公司Lorica Health。'
  },
  contactUs:{
    send:'发送消息',
    form:'联系我们',
    name:'请输入您的姓名',
    phone:'请输入您的手机号',
    email:'请输入您的邮箱',
    message:'请输入您想发送的消息',
    confirm:'提交',
    company:'请输入您的公司',
    address:'地址：浙江省杭州市上城区玉皇山基金小镇山南印4号楼B座408-409',
    emailAddress:'邮箱：zhuyongqi@datafareast.cn',
    ourPhone:'联系电话：0571-8678 2275'
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js